import { COMPANY } from "@/data";
import { Reveal } from "@/components/motion";

function LegalHero({ title }) {
  return (
    <section className="relative bg-ink text-white grain pt-40 pb-16 md:pt-48">
      <div className="relative z-10 mx-auto max-w-4xl px-5 md:px-8">
        <Reveal>
          <span className="overline text-xs uppercase tracking-[0.3em] text-gold font-medium">Rechtliches</span>
          <h1 className="mt-4 font-serif text-5xl md:text-6xl tracking-tight">{title}</h1>
        </Reveal>
      </div>
    </section>
  );
}

export default function Impressum() {
  return (
    <main data-testid="impressum-page">
      <LegalHero title="Impressum" />
      <section className="bg-cream py-20 md:py-24">
        <div className="mx-auto max-w-4xl px-5 md:px-8 prose-legal space-y-10 text-neutral-700">
          <div>
            <h2 className="font-serif text-2xl text-ink mb-3">Angaben gemäß § 5 TMG</h2>
            <p className="leading-relaxed">
              {COMPANY.legalName}<br />
              Inhaber: {COMPANY.owners}<br />
              {COMPANY.address}
            </p>
          </div>
          <div>
            <h2 className="font-serif text-2xl text-ink mb-3">Kontakt</h2>
            <p className="leading-relaxed">
              Telefon: {COMPANY.phone}<br />
              E-Mail: {COMPANY.email}
            </p>
          </div>
          <div>
            <h2 className="font-serif text-2xl text-ink mb-3">Umsatzsteuer-ID / Steuernummer</h2>
            <p className="leading-relaxed text-neutral-500">
              Steuernummer: <em>[wird ergänzt]</em><br />
              Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG: <em>[wird ergänzt]</em>
            </p>
          </div>
          <div>
            <h2 className="font-serif text-2xl text-ink mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p className="leading-relaxed">{COMPANY.owners}, {COMPANY.address}</p>
          </div>
          <div>
            <h2 className="font-serif text-2xl text-ink mb-3">Streitschlichtung</h2>
            <p className="leading-relaxed">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
              {" "}<a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer" className="text-gold-dark underline underline-offset-2">https://ec.europa.eu/consumers/odr</a>.
              Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </div>
          <div>
            <h2 className="font-serif text-2xl text-ink mb-3">Haftung für Inhalte</h2>
            <p className="leading-relaxed">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
              Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
